import { render } from "./cell_share_tag.vue?vue&type=template&id=1d25fb7c"
import script from "./cell_share_tag.vue?vue&type=script&lang=ts"
export * from "./cell_share_tag.vue?vue&type=script&lang=ts"
script.render = render

export default script